<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="ip"
                    label="屏蔽IP段"
                    prop="ip"
                    :help="formErr.ip"
                    :validateStatus='!formErr.ip||formErr.ip==""?"":"error"'
            >
                <a-input
                        v-model="form.ip"
                        @change="(e) => { formErr.ip=''}"
                        @blur="(e) => {  form.ip = e.target.value.trim() }"
                />
            </a-form-model-item>
          <p style="width: 380px">提示：可屏蔽IP段的前两位或前三位，被屏蔽的IP段允许正常浏览页面以及发送询盘，但是询盘不进入到用户询盘列表中。</p>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "newForm",
        props: ["visible","title","editId"],
        data() {
            return {
                drawerConfig :{
                  width: 420,
                  maskClosable:false,
                  destroyOnClose: true
                },
                form: {
                  ip:""
                },
                formErr: {
                  ip:""
                },
                rules: {
                  ip: [{required: true, message: "请输入屏蔽的IP段 ", trigger: "blur"},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.ip)}  , trigger: "blur"  }, ],
                },
                layout: {
                    labelCol: { span:5},
                    wrapperCol: { span: 14 },
                },
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.administrator. EDIT_DATA({id: a}).then(res => {
                        let val = res.data.data.info
                        this.form = val
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        methods: {
            onClose() {
                this.$emit("changVisible", false);
                this.formErr={ ip:""}
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.administrator.SUBMIT_ADD : url = API.administrator.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
